var _style, _rect, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.94 120",
    style: {
      enableBackground: "new 0 0 110.94 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#E32827;}\r\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 110.94,
    height: 120
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 110.94,
    height: 120
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.95,96.61c-0.95,3.54-2.01,6.38-3.31,9.57l-1.06,2.72c-0.71,1.54-2.95,6.61-2.95,7.68h16.07 c-0.12-0.94-6.97-17.01-8.27-21.26L15.95,96.61z M36.03,116.57c0.24-1.42-0.12-3.54,0-5.2c0-1.54,0.24-3.07,0.47-4.49 c3.19-13.82,18.08-21.38,31.55-16.42c4.02,1.54,9.69,5.79,10.99,9.09c-0.83,0.71-4.25,3.66-5.08,3.9 c-3.43-5.55-11.93-10.16-21.15-6.5c-11.22,4.61-10.87,18.07-9.81,19.37c0.47,0.35-0.24,0.12,0.83,0.24h34.5 c1.18-1.89,9.81-23.39,11.34-26.69h7.44l10.04,22.68c0.47,0.59,0.35,0.35,0.59,0.59L107.63,3.43H3.19l0.12,108.66 c1.18-1.3,8.27-20.55,9.57-22.2c2.01-0.12,5.67-0.35,7.21,0.12c0.83,0.47,10.04,22.68,12.05,26.57H36.03z M92.98,95.43 c-0.59,3.78-2.24,7.68-3.54,10.98c-0.71,1.77-3.9,8.86-3.9,10.16h15.95c-0.12-1.3-3.43-8.98-4.14-10.63 C96.88,104.88,93.81,96.14,92.98,95.43L92.98,95.43z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAca);
export default __webpack_public_path__ + "static/media/ACA.bfd6ca5b9379cbd582d64cf5218640e2.svg";
export { ForwardRef as ReactComponent };